import React from "react";
import { Link } from "react-router-dom";
import searchImg from "../Images/virtuous_database_search.png"
import compoundImg from "../Images/virtuous_compounds.png"
import surveyImg from "../Images/organoleptic_profile-surveys.png"

import Header_home from "../Components/Partials/Header_home"

function Homepage(){
    return <>
    <section className="flex flex-col h-full antialiased bg-neutrals-900"> 
    <Header_home />
    <main
        className="container relative flex flex-col flex-auto gap-8 p-8 mx-auto my-8 md:p-10">
        <h1 className="text-3xl font-bold text-white">Virtuos tools in a nutshell</h1>
        <div className="gap-4 mb-8 space-y-2 text-lg text-white lg:columns-2">
            <p> This is the Virtuous Platform developed within the framework of the EU-funded Virtuous project (<a className="link_on_dark"
                    href="https://virtuoush2020.com/" target="_blank">virtuoush2020.com</a>). </p>
            <p> The project aims at creating a virtual tongue able to predict the organoleptic profile of Mediterranean
                ingredients and their effects on human homeostasis and health status. </p>
            <p> One of the major scientific objectives of the Virtuous project is the development of a user-friendly web
                service as a decision-supporting tool (DST) for a wide range of experts and users. In detail, the
                platform is designed and implemented with the ultimate goal of allowing its usage and application not
                only to highly specialized personnel with powerful computational machines and extensive bioinformatic
                expertise, but also to clinicians, dieticians or pathologists specializing in diets for patients with
                diabetes, food companies, and other professionals not expert in computational modelling or ICT. </p>
            <p>Here, you can have access to all the major functionalities and tools of the Virtuous Platform, including
                taste predictors, database exploration tools and organoleptic profile surveys.</p>
        </div>
        <hr />
        {/*tools*/}
        <h2 className="py-2 text-2xl font-bold text-white col-span-full">Choose one tools to start your analyze</h2>
        <div className="grid gap-4 p-4 bg-gray-100 rounded-3xl md:grid-cols lg:grid-cols-3 ">
            {/*tool card*/}
            <div className="w-full p-4 card-home card group">
                <div className="flex flex-col h-full gap-4 space-y-2 ">
                    <img src={searchImg} alt="Virtuous database search" className="w-40 h-40 p-4 bg-white rounded-full group-hover:scale-110 animation-smooth"/>
                    <h2 className="font-bold uppercase ">Virtuous Database Search</h2>
                    <hr />
                    <p className="h-full">Dynamic and interactive exploration of the FooDB (<a href="https://foodb.ca" className="link">foodb.ca</a>) </p>
                    <Link to="/foods" className="w-full text-center cta cta-primary">start</Link>
                </div>
            </div>
            {/*tool card*/}
            <div className="w-full p-4 card-home card">
                <div className="flex flex-col h-full gap-4 space-y-2 group">
                    <img src={compoundImg} alt="Virtuous Taste prediction"
                        className="w-40 h-40 p-4 bg-white rounded-full group-hover:scale-110 animation-smooth" />
                    <h2 className="font-bold uppercase ">Virtuous Taste prediction</h2>
                    <hr />
                    <p className="h-full">From molecular structure to taste sensation</p>
                    <Link to="/compounds" className="w-full text-center cta cta-primary">start</Link>
                </div>
            </div>
            {/*tool card*/}
            <div className="w-full p-4 card-home card">
                <div className="flex flex-col h-full gap-4 space-y-2 group">
                    <img src={surveyImg} alt="Organoleptic Profile Surveys"
                        className="w-40 h-40 p-4 bg-white rounded-full group-hover:scale-110 animation-smooth" />
                    <h2 className="font-bold uppercase ">Organoleptic Profile Survey</h2>
                    <hr />
                    <p className="h-full">Surveys dedicated to the characterisation of the wine’s and oil’s tastes from Virtuous partnerns and beyond. </p>
                    <Link to="/organoleptic" className="w-full text-center cta cta-primary">start</Link>
                </div>
            </div>
        </div>

        
    </main>
    </section>
    </>
}

export default Homepage;